import React from "react";

export default function LoadingBox() {
  return (
    <div className="loading h3c">
      <i className="fa fa-spinner fa-spin"></i> Sayfa yükleniyor...
    </div>
  );
}
